module.exports = __webpack_public_path__ + "static/img/no@2x.4dd9428f.png";